// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminTournamentDetailsContainer{
    display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: #0C0B20;
  background-size: cover;
  padding: 16px;
  padding-bottom: 120px;
  padding-top: 64px;
  position: relative;
  color: white;
  align-items: center;
}

.adminTournamentDetailsContainer > div{
    max-width: 500px;
    width: 100%;
}

.adminTournamentDetailsContainer .tabsContainer{
    display: flex;
    gap: 16px;
    margin: 16px 0 ;
}

.adminTournamentDetailsContainer .tabsContainer button{
    display: flex;
    padding: 8px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    color: #0C0B20;
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    border-radius: 4px;
    border: 1px solid #69C3C5;
    background: none;
    color: #69C3C5;
}

.adminTournamentDetailsContainer .tabsContainer button.active{
        border-radius: 4px;
        border: 1px solid #69C3C5;
        background: #69C3C5;
        color: #0C0B20;
}

.adminTournamentDetailsContainer .matchesList{
    display: flex;
    flex-direction: column;
    margin-top: 16px;
}

.adminTournamentDetailsContainer .matchesList>h3{
    margin-bottom: 16px;
}

.adminTournamentDetailsContainer .matchesList .matchItem{
    color: white;
    background-color: #07263b;
    padding: 16px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid white;
}

.adminTournamentDetailsContainer .matchesList .matchItem:nth-child(1){
    display: none;
}

.adminTournamentDetailsContainer .matchesList .matchItem p{
    font-size: 14px;
}

.adminTournamentDetailsContainer .searchBar input{
    width: 100%;
    padding: 8px;
    font-size: 16px;
}

.adminTournamentDetailsContainer .searchBar{
    margin-top: 16px;
}

.adminTournamentDetailsContainer .backButtonContainer{
    display: flex;
    justify-content: start;
    gap: 16px;
    align-items: center;
}

.adminTournamentDetailsContainer .backButtonContainer button{
    background: none;
    color: white;
    font-size: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
}

.adminTournamentDetailsContainer .tournamentSettings{
    background-color: white;
    width: 300px;
    margin-top: 40px;
    position: absolute;
    padding: 8px;
    border-radius: 8px;
}

.adminTournamentDetailsContainer .filterButtons{
    margin-top: 16px;
}

.adminTournamentDetailsContainer .filterButtons{
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
}

.adminTournamentDetailsContainer .filterButtons button{
    display: flex;
    padding: 8px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    color: #0C0B20;
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    /* 12px */
    border-radius: 4px;
border: 1px solid #69C3C5;
background: none;
color: #69C3C5;
}

.adminTournamentDetailsContainer .filterButtons button.active{
    border-radius: 4px;
    border: 1px solid #69C3C5;
    background: #69C3C5;
    color: #0C0B20;
}

.teamsList{
    margin-top: 16px;
}

.teamsList>h3{
    margin-bottom: 16px;
}

.teamsList .teamItem{
    color: white;
    background-color: #07263b;
    padding: 16px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid white;
    position: relative;
}

.teamsList .editButton{
    width: 32px;
    position: absolute;
    background: #07263b;
    border-radius: 4px;
    border: none;
    right: 16px;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/AdminDashboard/Tournament/AdminTournamentDetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;QACQ,kBAAkB;QAClB,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,kBAAkB;AACtB,yBAAyB;AACzB,gBAAgB;AAChB,cAAc;AACd;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB","sourcesContent":[".adminTournamentDetailsContainer{\r\n    display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  background: #0C0B20;\r\n  background-size: cover;\r\n  padding: 16px;\r\n  padding-bottom: 120px;\r\n  padding-top: 64px;\r\n  position: relative;\r\n  color: white;\r\n  align-items: center;\r\n}\r\n\r\n.adminTournamentDetailsContainer > div{\r\n    max-width: 500px;\r\n    width: 100%;\r\n}\r\n\r\n.adminTournamentDetailsContainer .tabsContainer{\r\n    display: flex;\r\n    gap: 16px;\r\n    margin: 16px 0 ;\r\n}\r\n\r\n.adminTournamentDetailsContainer .tabsContainer button{\r\n    display: flex;\r\n    padding: 8px 12px;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 4px;\r\n    color: #0C0B20;\r\n    text-align: center;\r\n    font-family: Lato;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 100%;\r\n    border-radius: 4px;\r\n    border: 1px solid #69C3C5;\r\n    background: none;\r\n    color: #69C3C5;\r\n}\r\n\r\n.adminTournamentDetailsContainer .tabsContainer button.active{\r\n        border-radius: 4px;\r\n        border: 1px solid #69C3C5;\r\n        background: #69C3C5;\r\n        color: #0C0B20;\r\n}\r\n\r\n.adminTournamentDetailsContainer .matchesList{\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-top: 16px;\r\n}\r\n\r\n.adminTournamentDetailsContainer .matchesList>h3{\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.adminTournamentDetailsContainer .matchesList .matchItem{\r\n    color: white;\r\n    background-color: #07263b;\r\n    padding: 16px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    border-bottom: 1px solid white;\r\n}\r\n\r\n.adminTournamentDetailsContainer .matchesList .matchItem:nth-child(1){\r\n    display: none;\r\n}\r\n\r\n.adminTournamentDetailsContainer .matchesList .matchItem p{\r\n    font-size: 14px;\r\n}\r\n\r\n.adminTournamentDetailsContainer .searchBar input{\r\n    width: 100%;\r\n    padding: 8px;\r\n    font-size: 16px;\r\n}\r\n\r\n.adminTournamentDetailsContainer .searchBar{\r\n    margin-top: 16px;\r\n}\r\n\r\n.adminTournamentDetailsContainer .backButtonContainer{\r\n    display: flex;\r\n    justify-content: start;\r\n    gap: 16px;\r\n    align-items: center;\r\n}\r\n\r\n.adminTournamentDetailsContainer .backButtonContainer button{\r\n    background: none;\r\n    color: white;\r\n    font-size: 32px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border: none;\r\n}\r\n\r\n.adminTournamentDetailsContainer .tournamentSettings{\r\n    background-color: white;\r\n    width: 300px;\r\n    margin-top: 40px;\r\n    position: absolute;\r\n    padding: 8px;\r\n    border-radius: 8px;\r\n}\r\n\r\n.adminTournamentDetailsContainer .filterButtons{\r\n    margin-top: 16px;\r\n}\r\n\r\n.adminTournamentDetailsContainer .filterButtons{\r\n    display: flex;\r\n    gap: 12px;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.adminTournamentDetailsContainer .filterButtons button{\r\n    display: flex;\r\n    padding: 8px 12px;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 4px;\r\n    color: #0C0B20;\r\n    text-align: center;\r\n    font-family: Lato;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 100%;\r\n    /* 12px */\r\n    border-radius: 4px;\r\nborder: 1px solid #69C3C5;\r\nbackground: none;\r\ncolor: #69C3C5;\r\n}\r\n\r\n.adminTournamentDetailsContainer .filterButtons button.active{\r\n    border-radius: 4px;\r\n    border: 1px solid #69C3C5;\r\n    background: #69C3C5;\r\n    color: #0C0B20;\r\n}\r\n\r\n.teamsList{\r\n    margin-top: 16px;\r\n}\r\n\r\n.teamsList>h3{\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.teamsList .teamItem{\r\n    color: white;\r\n    background-color: #07263b;\r\n    padding: 16px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    border-bottom: 1px solid white;\r\n    position: relative;\r\n}\r\n\r\n.teamsList .editButton{\r\n    width: 32px;\r\n    position: absolute;\r\n    background: #07263b;\r\n    border-radius: 4px;\r\n    border: none;\r\n    right: 16px;\r\n    color: white;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
